/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Budget_UsedInputs */

const en_ai_budget_used = /** @type {(inputs: Ai_Budget_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget used`)
};

const de_ai_budget_used = /** @type {(inputs: Ai_Budget_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget verbraucht`)
};

/**
* | output |
* | --- |
* | "Budget used" |
*
* @param {Ai_Budget_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_budget_used = /** @type {((inputs?: Ai_Budget_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Budget_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_budget_used(inputs)
	return en_ai_budget_used(inputs)
});